import { html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

export const Template = ({ variant, fullHeight, className, _slot }) => html`
    <ux-iws-sf-page
        variant=${ifDefined(variant)}
        ?full-height=${ifDefined(fullHeight)}
        class=${ifDefined(className)}
    >
        ${unsafeHTML(_slot)}
    </ux-iws-sf-page>
`;

export const exampleSlot = `
<ux-iws-sf-page-content>
    <ux-iws-sf-page-body>
        <ux-iws-sf-page-title variant="h1-logo"><h1>Registration</h1></ux-iws-sf-page-title>
        <form class="ux-u-my-zero">
            <div class="ux-row">
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-select
                        class="ux-u-w-100"
                        label="Form of Address"
                        name="formOfAddress"
                    >
                        <option value="">Please select ...</option>
                        <option value="Sample Form of Address">Sample Form of Address</option>
                    </ux-select>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-select
                        class="ux-u-w-100"
                        label="Country"
                        name="country"
                        required
                    >
                        <option value="DE">Germany</option>
                        <option value="AT">Austria</option>
                        <option value="CH">Switzerland</option>
                        <option value="FR">France</option>
                        <option value="IT">Italy</option>
                        <option value="UK">United Kingdom</option>
                        <option value="US">United States</option>
                    </ux-select>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-input-field
                        label="First Name"
                        type="text"
                        name="firstName"
                        required
                        placeholder="Enter your first name"
                    ></ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-input-field
                        label="Last Name"
                        type="text"
                        name="lastName"
                        required
                        placeholder="Enter your last name"
                    ></ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-input-field
                        label="E-Mail"
                        type="email"
                        name="email"
                        required
                        placeholder="Enter your email address"
                    ></ux-input-field>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-phone-input
                        label="Phone Number"
                        type="text"
                        name="phoneNumber"
                        country="DE"
                        country-options="BR,BG,CA,CN,DE,ES,FR,IN,IT,HU,NL,PL,PT,RO,CH,SG,SK,SE,TR,GB,US,VN,AT,CZ,TH,TW,JP,KR"
                    ></ux-phone-input>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-select
                        class="ux-u-w-100"
                        label="Reason of Registration"
                        name="reasonOfRegistration"
                        required
                    >
                        <option value="">Please select ...</option>
                        <option value="Sample Reason of Registration">Sample Reason of Registration</option>
                    </ux-select>
                </div>
                <div class="ux-col-12 ux-col-sm-6 ux-u-mb-xxs">
                    <ux-select
                        class="ux-u-w-100"
                        label="Department"
                        name="department"
                        required
                    >
                        <option value="">Please select ...</option>
                        <option value="Sample Department">Sample Department</option>
                    </ux-select>
                </div>
            </div>
            <div class="ux-u-mb-xxxs">
                <ux-checkbox name="acceptTerms">
                    I hereby accept the
                    <a href="#terms">terms of use</a>
                </ux-checkbox>
            </div>
            <div class="ux-u-mb-xxxs">
                <ux-checkbox name="acceptPrivacyPolicy">
                    I hereby accept the
                    <a href="#privacy-policy">privacy policy</a>
                </ux-checkbox>
            </div>
            <div class="ux-u-my-xs ux-text-normal--light-gray ux-text-small">Mandatory fields are marked with *.</div>
            <div class="ux-u-my-xs">
                <ux-iws-captcha
                  sitekey="FCMJCSQ29M7LEOV4"
                  language="de"
                  prevent-submit
                ></ux-iws-captcha>
            </div>
            <div class="ux-u-mt-s ux-u-d-flex ux-u-flex-jc-between ux-u-flex-jc-center ux-u-flex-gap-xxs ux-u-flex-wrap-wrap">
                <ux-button>Cancel</ux-button>
                <ux-button type="submit" variant="primary">Register</ux-button>
            </div>
        </form>
    </ux-iws-sf-page-body>
    <ux-iws-sf-cta-footer>
        <p slot="text">Already have an account?</p>
        <ux-button slot="cta">Login now</ux-button>
    </ux-iws-sf-cta-footer>
</ux-iws-sf-page-content>`;
